
export enum WellKnownGroupType {
  Unknown = 0,
  Visitor = 1,
  Member = 2,
  Owner = 3
}
